/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2578
 */

var r = require(/* 2579 */"./2579/index")
var i = require(/* 2581 */"./2581")(r)
module.exports = i
